(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lg-editorial-catalogue"] && !Shopify.designMode) return;
  try {
    
  class LgEditorialCatalogue {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('[data-catalogue-track]');
      this.viewport = element.querySelector('[data-catalogue-viewport]');
      this.slides = Array.from(element.querySelectorAll('[data-catalogue-slide]'));
      this.dots = Array.from(element.querySelectorAll('[data-catalogue-dot]'));
      this.status = element.querySelector('[data-catalogue-status]');
      this.toggle = element.querySelector('[data-catalogue-toggle]');
      this.index = 0;
      this.timer = null;
      this.paused = false;
      this.pointerStart = null;
      this.autoplay = element.dataset.autoplay === 'true';
      this.pauseHover = element.dataset.pauseHover === 'true';
      this.interval = Number(element.dataset.interval) || 5000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.bind();
      this.update(0, false);
      this.start();
    }

    bind() {
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.catalogueDot))));
      this.element.querySelector('[data-catalogue-previous]')?.addEventListener('click', () => this.go(this.index - 1));
      this.element.querySelector('[data-catalogue-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.toggle?.addEventListener('click', () => this.toggleAutoplay());
      this.viewport?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.index - 1);
        if (event.key === 'ArrowRight') this.go(this.index + 1);
      });
      this.viewport?.setAttribute('tabindex', '0');
      this.viewport?.addEventListener('pointerdown', (event) => {
        this.pointerStart = event.clientX;
      });
      this.viewport?.addEventListener('pointerup', (event) => {
        if (this.pointerStart === null) return;
        const distance = event.clientX - this.pointerStart;
        this.pointerStart = null;
        if (Math.abs(distance) < 45) return;
        this.go(distance > 0 ? this.index - 1 : this.index + 1);
      });
      if (this.pauseHover) {
        this.element.addEventListener('mouseenter', () => this.stop());
        this.element.addEventListener('mouseleave', () => this.start());
        this.element.addEventListener('focusin', () => this.stop());
        this.element.addEventListener('focusout', () => this.start());
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.start();
      });
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.element.contains(event.target)) return;
        const slide = event.target.closest('[data-catalogue-slide]');
        if (slide) this.go(Number(slide.dataset.index), false);
        this.stop();
      });
    }

    go(index, restart = true) {
      if (!this.slides.length) return;
      const next = (index + this.slides.length) % this.slides.length;
      this.update(next, true);
      if (restart) {
        this.stop();
        this.start();
      }
    }

    update(index, playVideo) {
      this.index = index;
      this.track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        const video = slide.querySelector('video');
        if (!video) return;
        if (active && playVideo) video.play().catch(() => {});
        if (!active) video.pause();
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
      if (this.status) {
        const current = String(index + 1).padStart(2, '0');
        const total = String(this.slides.length).padStart(2, '0');
        this.status.textContent = `${current} / ${total}`;
      }
    }

    start() {
      if (!this.autoplay || this.paused || this.reduced || this.slides.length < 2 || this.timer) return;
      this.timer = window.setInterval(() => this.update((this.index + 1) % this.slides.length, true), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    toggleAutoplay() {
      this.paused = !this.paused;
      this.toggle.setAttribute('aria-pressed', String(this.paused));
      this.toggle.setAttribute('aria-label', this.paused ? 'Resume automatic advance' : 'Pause automatic advance');
      const label = this.toggle.querySelector('[data-catalogue-toggle-label]');
      if (label) label.textContent = this.paused ? 'Play' : 'Pause';
      const icon = this.toggle.querySelector('[data-catalogue-toggle-icon]');
      if (icon) icon.textContent = this.paused ? '▶' : 'Ⅱ';
      if (this.paused) this.stop();
      else this.start();
    }
  }

  const initializeLgCatalogues = (root = document) => {
    root.querySelectorAll('[data-lg-catalogue]').forEach((element) => {
      if (element.dataset.catalogueReady === 'true') return;
      element.dataset.catalogueReady = 'true';
      new LgEditorialCatalogue(element);
    });
  };

  initializeLgCatalogues();
  document.addEventListener('shopify:section:load', (event) => initializeLgCatalogues(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-inspiration-board"] && !Shopify.designMode) return;
  try {
    
  const resetFlushBoard = (board) => {
    const collection = board.querySelector('.lg-board__collection');
    if (!collection) return;

    collection.classList.remove('lg-board__collection--flush-ready');
    collection.style.height = '';

    collection.querySelectorAll('.lg-board__item').forEach((item) => {
      item.style.left = '';
      item.style.top = '';
      item.style.width = '';
    });

    collection.querySelectorAll('.lg-board__figure--flush').forEach((figure) => {
      figure.classList.remove('lg-board__figure--flush');
      figure.style.removeProperty('--lg-flush-figure-height');
    });
  };

  const flushBoardBottom = (board) => {
    resetFlushBoard(board);
    if (board.dataset.flushBottom !== 'true' || window.innerWidth < 990) return;

    const collection = board.querySelector('.lg-board__collection');
    const items = Array.from(collection.querySelectorAll(':scope > .lg-board__item'));
    if (!items.length) return;

    if (board.lgFlushFrame) window.cancelAnimationFrame(board.lgFlushFrame);
    board.lgFlushFrame = window.requestAnimationFrame(() => {
      board.lgFlushFrame = null;
      const collectionRect = collection.getBoundingClientRect();
      const measurements = items.map((item) => {
        const rect = item.getBoundingClientRect();
        return {
          item,
          left: rect.left - collectionRect.left,
          top: rect.top - collectionRect.top,
          width: rect.width,
          bottom: rect.bottom - collectionRect.top
        };
      });
      const targetBottom = Math.max(...measurements.map((measurement) => measurement.bottom));
      const fullWidthLast = measurements.some((measurement) => {
        return measurement.width >= collectionRect.width * 0.9 && targetBottom - measurement.bottom < 2;
      });
      const columnBottoms = new Map();

      if (!fullWidthLast) {
        measurements.forEach((measurement) => {
          if (measurement.width >= collectionRect.width * 0.9) return;
          const columnKey = Math.round(measurement.left);
          const current = columnBottoms.get(columnKey);
          if (!current || measurement.bottom > current.bottom) {
            columnBottoms.set(columnKey, measurement);
          }
        });
      }

      measurements.forEach((measurement) => {
        measurement.item.style.left = `${measurement.left}px`;
        measurement.item.style.top = `${measurement.top}px`;
        measurement.item.style.width = `${measurement.width}px`;
      });

      columnBottoms.forEach((measurement) => {
        const growth = targetBottom - measurement.bottom;
        if (growth < 1) return;
        const figure = measurement.item.querySelector('.lg-board__figure');
        if (!figure) return;
        const figureHeight = figure.getBoundingClientRect().height;
        figure.classList.add('lg-board__figure--flush');
        figure.style.setProperty('--lg-flush-figure-height', `${figureHeight + growth}px`);
      });

      collection.style.height = `${targetBottom}px`;
      collection.classList.add('lg-board__collection--flush-ready');
    });
  };

  const initializeFlushBoards = (root = document) => {
    root.querySelectorAll('.lg-board[data-flush-bottom="true"]').forEach((board) => {
      board.querySelectorAll('img, video').forEach((media) => {
        if (media.complete || media.readyState >= 2) return;
        media.addEventListener('load', () => flushBoardBottom(board), { once: true });
        media.addEventListener('loadedmetadata', () => flushBoardBottom(board), { once: true });
      });
      flushBoardBottom(board);
    });
  };

  let flushBoardResizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(flushBoardResizeTimer);
    flushBoardResizeTimer = window.setTimeout(() => initializeFlushBoards(), 120);
  });
  document.addEventListener('shopify:section:load', (event) => initializeFlushBoards(event.target));
  document.addEventListener('shopify:section:reorder', () => initializeFlushBoards());
  initializeFlushBoards();

  class LgBoardMobileFlush {
    constructor(section) {
      this.section = section;
      this.collection = section.querySelector('.lg-board__collection');
      this.enabled = section.dataset.flushMobile === 'true';
      this.timer = null;
      this.bind();
      this.schedule();
    }

    bind() {
      window.addEventListener('resize', () => this.schedule());
      this.section.querySelectorAll('img, video').forEach((media) => {
        media.addEventListener('load', () => this.schedule(), { once: true });
        media.addEventListener('loadedmetadata', () => this.schedule(), { once: true });
      });
      document.addEventListener('shopify:block:select', (event) => {
        if (this.section.contains(event.target)) this.schedule();
      });
    }

    reset() {
      this.section.querySelectorAll('.lg-board__figure--flush-mobile').forEach((figure) => {
        figure.classList.remove('lg-board__figure--flush-mobile');
        figure.style.removeProperty('height');
      });
    }

    schedule() {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => this.apply(), 140);
    }

    apply() {
      this.reset();
      if (!this.enabled || window.innerWidth > 749 || !this.collection) return;
      if (getComputedStyle(this.collection).columnCount === '1') return;
      window.requestAnimationFrame(() => {
        const items = Array.from(this.collection.querySelectorAll('.lg-board__item:not(.lg-board__item--featured)'));
        const columns = new Map();
        items.forEach((item) => {
          const key = Math.round(item.offsetLeft);
          const current = columns.get(key);
          if (!current || item.offsetTop > current.offsetTop) columns.set(key, item);
        });
        if (columns.size < 2) return;
        const endings = Array.from(columns.values());
        const baseline = Math.max(...endings.map((item) => item.offsetTop + item.offsetHeight));
        endings.forEach((item) => {
          const difference = baseline - (item.offsetTop + item.offsetHeight);
          if (difference < 2) return;
          const figure = item.querySelector('.lg-board__figure');
          if (!figure) return;
          figure.style.height = `${Math.round(figure.getBoundingClientRect().height + difference)}px`;
          figure.classList.add('lg-board__figure--flush-mobile');
        });
      });
    }
  }

  const initializeMobileFlushBoards = (root = document) => {
    root.querySelectorAll('[data-lg-board-mobile]').forEach((section) => {
      if (section.dataset.mobileFlushReady === 'true') return;
      section.dataset.mobileFlushReady = 'true';
      new LgBoardMobileFlush(section);
    });
  };

  initializeMobileFlushBoards();
  document.addEventListener('shopify:section:load', (event) => initializeMobileFlushBoards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
